import React, { useEffect, useRef, useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./calendercustom.css";
import { TextField, Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { endDateFunc, startDateFunc } from "../../redux/actions/dateData.action";

const DateRangePicker = () => {
    const [showStartCalendar, setShowStartCalendar] = useState(false);
    const [showEndCalendar, setShowEndCalendar] = useState(false);
    const dispatch = useDispatch();

    const { startDate, endDate } = useSelector((state) => state.DateDataStorage);

    const startCalendarRef = useRef(null);
    const endCalendarRef = useRef(null);

    const formatDate = (date) => {
        if (!date) return "";
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    useEffect(() => {
        if (!startDate && !endDate) {
            const today = new Date();
            const last30Days = new Date();
            last30Days.setDate(today.getDate() - 30);
            dispatch(startDateFunc(formatDate(last30Days)));
            dispatch(endDateFunc(formatDate(today)));
        }
    }, [dispatch, startDate, endDate]);

  
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                startCalendarRef.current && !startCalendarRef.current.contains(event.target) &&
                endCalendarRef.current && !endCalendarRef.current.contains(event.target)
            ) {
                setShowStartCalendar(false);
                setShowEndCalendar(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // Handle Start Date Selection
    const handleStartDateChange = (date) => {
        dispatch(startDateFunc(formatDate(date)));
        setShowStartCalendar(false);
    };

    // Handle End Date Selection
    const handleEndDateChange = (date) => {
        dispatch(endDateFunc(formatDate(date)));
        setShowEndCalendar(false);
    };

    // Show/Hide Calendar
    const handleShow = (type) => {
        if (type === "start") {
            setShowStartCalendar(true);
            setShowEndCalendar(false);
        } else {
            setShowStartCalendar(false);
            setShowEndCalendar(true);
        }
    };

    return (
        <Box display="flex"  gap={2}>
            {/* Start Date Picker */}
            <Box position="relative" ref={startCalendarRef}  width={`100%`}>
                <TextField
                    type="text"
                    label="Starting Date"
                    variant="outlined"
                    fullWidth
                    value={startDate || ""}
                    onFocus={() => handleShow("start")}
                    InputProps={{ readOnly: true }}
                />
                {showStartCalendar && (
                    <Box position="absolute" zIndex={2} width={`100%`} bgcolor="white" boxShadow={3}>
                        <Calendar
                            onChange={handleStartDateChange}
                            selectRange={false}
                            className="custom-calendar"
                        />
                    </Box>
                )}
            </Box>

            {/* End Date Picker */}
            <Box position="relative" ref={endCalendarRef} width={`100%`}>
                <TextField
                    type="text"
                    label="Ending Date"
                    variant="outlined"
                    fullWidth
                    value={endDate || ""}
                    onFocus={() => handleShow("end")}
                    InputProps={{ readOnly: true }}
                />
                {showEndCalendar && (
                    <Box position="absolute" zIndex={2} bgcolor="white" width={`100%`} boxShadow={3}>
                        <Calendar
                            onChange={handleEndDateChange}
                            selectRange={false}
                            // minDate={startDate ? new Date(startDate) : null}
                            className="custom-calendar"
                        />
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default DateRangePicker;
